/*********************** Custom JS for Boost AI Search & Discovery  ************************/
boostSDAppConfig.filterSettings.disabledScrollToTopAfterFilter = true;
console.log('12321');
const scrollToTopProductGrid = () => {
    const boostSDRight = document.querySelector('.boost-sd-right');
    if (!boostSDRight) return;
    const yBoostSDRight = boostSDRight.getBoundingClientRect()?.top;
    if (yBoostSDRight !== undefined && window.scrollY > yBoostSDRight) {
        window.scrollTo({
            top: yBoostSDRight + window.scrollY - 150,
            behavior: "smooth"
        });
    }
};
const customize = {
    updateProductItemGrid: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'Scroll to product grid position',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        scrollToTopProductGrid();
                    } catch (e) {
                        console.warn(e);
                    }
                }
            }),
        });
    }
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);